import ManifestImage from './ManifestImage'

export default ManifestImage
